// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"413dd6bf","488":"ace23437"}[chunkId] + ".chunk.js";
};